module.exports = {"key":"KBTlenXpQ3BnyJUD","token":"Yh3PrmY54jOFKdES"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/keymsg.json
// module id = fbxe
// module chunks = 3